import { render, staticRenderFns } from "./UnQualified.vue?vue&type=template&id=5ac198d5&scoped=true"
import script from "./UnQualified.vue?vue&type=script&lang=ts"
export * from "./UnQualified.vue?vue&type=script&lang=ts"
import style0 from "./UnQualified.vue?vue&type=style&index=0&id=5ac198d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac198d5",
  null
  
)

export default component.exports